import React, {useEffect, useState} from 'react';
import UserService from 'src/services/UserService';
import AcceptTermsOfUseModal from './accept-terms-of-use-modal';
import RejectTermsOfUseModal from './reject-terms-of-use-modal';

interface Props {
  deleteAccountClicked?: boolean;
}

const TermsOfUseModal = ({deleteAccountClicked = false}: Props) => {
  const [deleteAccountSelected, setDeleteAccountSelected] = useState(deleteAccountClicked);
  const [termsOfUseConfirmed, setTermsOfUseConfirmed] = useState<boolean | null>(null);

  useEffect(() => {
    UserService.getData(['latestTermsOfUseConfirmed']).then((data) => {
      const {latestTermsOfUseConfirmed} = data as {latestTermsOfUseConfirmed: boolean};
      setTermsOfUseConfirmed(latestTermsOfUseConfirmed);
    });
  }, []);

  if (termsOfUseConfirmed === null || termsOfUseConfirmed) {
    return null;
  }

  return deleteAccountSelected ? (
    <RejectTermsOfUseModal onGoBackClick={() => setDeleteAccountSelected(false)} />
  ) : (
    <AcceptTermsOfUseModal
      onClickDeleteAccount={() => setDeleteAccountSelected(true)}
      setTermsOfUseConfirmed={setTermsOfUseConfirmed}
    />
  );
};

export default TermsOfUseModal;
